import React from "react"
import { useTheme } from "@mui/material"
import { PaymentTiming } from "@/types/enums/PaymentTiming"
import { PaymentInlineIndicator, type PaymentInlineIndicatorSize } from "@/components/order/PaymentInlineIndicator"
import { resolvePaymentTimingIndicatorPresentation } from "@/components/order/payment-timing-presentation"

export type PaymentTimingIndicatorProps = {
  paymentTiming: PaymentTiming
  size?: PaymentInlineIndicatorSize
}

export function PaymentTimingIndicator({ paymentTiming, size = "default" }: PaymentTimingIndicatorProps) {
  const theme = useTheme()
  const { label, Icon, accentColor } = resolvePaymentTimingIndicatorPresentation(paymentTiming, theme)

  return (
    <PaymentInlineIndicator
      className="payment-timing-indicator"
      label={label}
      Icon={Icon}
      accentColor={accentColor}
      ariaLabel={`Payment timing: ${label}`}
      size={size}
    />
  )
}

export default PaymentTimingIndicator
